module.exports = __webpack_public_path__ + "img/icon-sel-box-small.9754667b.svg";